export const ctaFields = `
    buttonLabel
    type
    link {
        url
        title
        target
    }
    file {
      node {
        mediaItemUrl
      }
    }
    page {
      nodes {
        ... on Page {
          uri
          title
        }
      }
    }
`;

export const image = `
  node {
      id
      altText
      caption
      sourceUrl
      mediaDetails {
          width
          height
      }
      blurPlaceholder
  }
`;

export const video = `
  node {
    id
    caption
    mediaItemUrl
    mediaDetails {
      height
      width
    }
  }
`;

// export const projectCard = `
//   link {
//     url
//     title
//   }
//   heading
//   label
//   image {
//     id
//     altText
//     caption
//     sourceUrl
//     width
//     height
//     blurPlaceholder
//   }
// `;
export const projectCard = `
  databaseId
  hasDeepDive
  link {
    url
    title
  }
  heading
  subheading
  label
  eventDate
  eventTime
  taxonomies {
    name
    slug
    taxonomy
  }
  image {
    id
    altText
    caption
    sourceUrl
    width
    height
    blurPlaceholder
  }
`;
